/* eslint-disable no-unused-vars */
import { Grid } from "@mui/material";
import PDialog from "../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import { PDFObject } from "react-pdfobject";
import API from "../../utils/API";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function GenericReportViewer(props) {
  const { t } = useTranslation();
  const translate = t;
  const [openWindow, setOpenWindow] = useState(false);
  const [mode, setMode] = useState("view");
  const [windowTitile, setWindowTitle] = useState("Report Viewer");
  const [reportUrl, setReportUrl] = useState("");

  useEffect(() => {}, []);

  props.biRef.genericReportView = {
    showGenericReportViewer: showGenericReportViewer,
  };

  function showGenericReportViewer(template, paramsList, title, pluginMode) {
    setOpenWindow(true);
    setWindowTitle(title);
    generateReport(template, paramsList, pluginMode);
  }

  async function generateReport(reportTemplate, reportParamsList, pluginMode) {
    console.log("pluginMode", pluginMode);
    let reportReq = {
      template: reportTemplate,
      outFormat: "pdf",
      paramList: reportParamsList,
      pluginMode: pluginMode ? pluginMode : null,
    };
    try {
      let { data } = await API.post("/report/generate", reportReq);
      setReportUrl("/report/download/" + data.fileName);
    } catch (e) {
      console.log("Error while generating report", e);
      setOpenWindow(false);
    }
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }
  function onDelete() {}
  async function onSave() {}

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ height: "100%" }}>
        {reportUrl.length > 0 ? (
          <PDFObject
            url={reportUrl}
            height={"100vh"}
            pdfOpenParams={{
              view: "FitV",
              pagemode: "none",

              navpanes: 0,
            }}
          />
        ) : (
          <div style={{ height: "100vh" }}>
            <PDialog
              content={
                <Grid container style={{ width: 300, margin: 20 }}>
                  <Grid item xs={12}>
                    <CircularProgress disableShrink />
                    {translate("Please wait report is rendering...")}
                  </Grid>
                </Grid>
              }
              maxWidth={"md"}
              fullWidth={false}
              open={true}
              borderLess={true}
            ></PDialog>
          </div>
        )}
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitile}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          overFlow={"hidden"}
        ></PDialog>
      )}
    </div>
  );
}
